import Table from "@/domain/restaurant/Table";
import Restaurant from "@/domain/restaurant/Restaurant";
import Room from "@/domain/restaurant/Room";

export default class UtilService {
  static equals(o1: Object, o2: Object) {
    return (
      JSON.stringify(o1, Object.keys(o1).sort()) ===
      JSON.stringify(o2, Object.keys(o2).sort())
    );
  }

  static arrayEquals(o1: Object[], o2: Object[]) {
    if (o1 == null && o2 == null) return true;
    if (o1 == null || o2 == null) {
      return false;
    }
    o1.sort();
    o2.sort();
    return JSON.stringify(o1) === JSON.stringify(o2);
  }

  static removeFromArray(array: any[], toRemove: any) {
    for (let index = 0; index < array.length; index++) {
      if (UtilService.equals(toRemove, array[index])) {
        array.splice(index, 1);
        return;
      }
    }
    console.log("Item: " + toRemove.toString() + " not in array");
  }

  static stringComparatorAscending = (name1: any, name2: any) => {
    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }
    return 0;
  };

  static getTableDict(rest: Restaurant): { [key: number]: Table } {
    const tableDict: { [key: number]: Table } = {};
    if (rest == null || rest.rooms == null) return {};
    for (let i = 0; i < rest.rooms.length; i++)
      for (let j = 0; j < rest.rooms[i].tables.length; j++) {
        tableDict[rest.rooms[i].tables[j].tableId] = rest.rooms[i].tables[j];
      }
    return tableDict;
  }

  static getRoomDict(rest: Restaurant): { [key: number]: Room } {
    const roomDict: { [key: number]: Room } = {};
    for (let i = 0; i < rest.rooms.length; i++)
      roomDict[rest.rooms[i].roomId] = rest.rooms[i];
    return roomDict;
  }
}
